/* 
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved. 
* Distributed under the TruVideo proprietary license. 
*/
import apiClient from '../api/client';

/**
 * Role Management Service
 * Handles custom and system roles scoped to the account.
 */
export const roleService = {
  /**
   * List Roles - GET /api/roles
   * Supports filtering by search, scope, and type
   */
  getRoles: async (params = {}) => {
    return apiClient.get('/roles', { params });
  },

  /**
   * Get Role Detail - GET /api/roles/:id
   */
  getRoleById: async (id) => {
    return apiClient.get(`/roles/${id}`);
  },

  /**
   * Create Custom Role - POST /api/roles
   * Payload: name, displayName, scope, isDefault, permissionIds (array of UUIDs)
   */
  createRole: async (payload) => {
    return apiClient.post('/roles', payload);
  },

  /**
   * Update Custom Role - PATCH /api/roles/:id
   * Payload: displayName, scope, isDefault, permissionIds
   */
  updateRole: async (id, payload) => {
    return apiClient.patch(`/roles/${id}`, payload);
  },

  /**
   * Delete Custom Role - DELETE /api/roles/:id
   */
  deleteRole: async (id) => {
    return apiClient.delete(`/roles/${id}`);
  },

  /**
   * List All Permissions - GET /api/permissions
   * Returns a list of all predefined system permissions
   */
  getPermissions: async () => {
    return apiClient.get('/permissions');
  }
};
